import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import Headers from './Header';
import NavigationBar from './Navigation';
import Loader from '../common/Loader';
import SessionType from '../common/SessionType';
import { PATH } from '../../../utils/Constants';
import banner from '../../../utils/images/dashboardBanner.svg';
import { getAppointmentDetails, getDashboardDetails } from '../../action/educator/DashboardAction';
import SessionStatusButton from '../common/SessionStatusButton';
import { InPerson, OnDemand, Scheduled } from '../../../utils/common/NamingTerms';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import { LanguageProvider, useLanguage } from '../../../utils/common/LanguageContext';
import AppConfig from '../../../utils/common/DomainConfiguration';

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */

// HOC to inject language context into class component
const withLanguage = (Component) => {
    return (props) => {
        const { t } = useLanguage();
        return <Component {...props} t={t} />;
    };
};

class PhysicianDashBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNav: false,
            tabName: 'upcoming',
            isLoading: false,
            isAppointmentLoading: false,
            sessionIndex: 0,
        };
    }

    //componentDidUpdate
    componentDidUpdate(prevProps) {
        if (this.props.deactivateUserScreen !== prevProps.deactivateUserScreen) {
            clearInterval(this.timer);
        }
    }

    // componentWillMount
    componentWillMount() {
        this.getDashboardDetails();
        this.getAppointmentDetails();
        this.timer = setInterval(() => {
            this.getAppointmentDetails();
        }, 30000);
    }

    //componentWillUnmount
    componentWillUnmount() {
        clearInterval(this.timer);
    }

    // getDashboardDetails
    getDashboardDetails = () => {
        this.isLoading();
        this.props.getDashboardDetails((result) => {
            this.isLoading();
        });
    };

    // getAppointmentDetails
    getAppointmentDetails = () => {
        this.setState({ isAppointmentLoading: true });
        this.props.getAppointmentDetails((result) => {
            this.setState({ isAppointmentLoading: false });
        });
    };

    //onClickMobileNav
    onClickMobileNav = (type) => {
        this.setState({ mobileNav: type });
    };

    //isLoading
    isLoading() {
        this.setState({ isLoading: !this.state.isLoading });
    }

    /**
     * Render page
     */
    render() {
        const { sessionIndex } = this.state;
        const {
            todaySession,
            previousSession,
            // manageSchedule,
            upcomingSession,
            userDetails,
        } = this.props;
        return (
            <div className="fixed top-0 left-0 flex w-full h-full">
                <div
                    className={`bg-black bg-opacity-50 fixed top-0 left-0 w-full h-full z-10 ${
                        this.state.mobileNav ? 'block' : 'hidden'
                    }`}
                ></div>
                <NavigationBar
                    nav={true}
                    {...this.props}
                    active={PATH.IM_PHYSICIAN.DASHBOARD}
                    mobileNav={this.state.mobileNav}
                    onClickMobileNav={this.onClickMobileNav}
                />
                <main className="flex flex-col flex-grow">
                    <Headers
                        {...this.props}
                        title={this.props.t('home')}
                        onClickMobileNav={this.onClickMobileNav}
                    />
                    <div className="flex flex-col w-full h-full py-8 overflow-auto bg-UIBackground">
                        {this.state.isLoading ? (
                            <Loader />
                        ) : (
                            <>
                                <div className="items-center justify-between px-4 sm:flex">
                                    <div className="w-full rounded-2xl sm:flex justify-between items-center bg-gradient-to-r from-[#58429a] via-[#3c305e] to-[#342a59]">
                                        <div className="p-4 sm:p-6">
                                            <h6
                                                className="mb-2 text-4xl font-medium text-white sm:text-3xl"
                                                title={`${userDetails.firstName} ${userDetails.lastName}`}
                                            >
                                                {this.props.t('hi')},
                                                {` ${userDetails.firstName} ${userDetails.lastName}`}
                                            </h6>
                                            <p className="mb-0 text-white">
                                                {this.props.t('welcomeToBloomlink')}
                                            </p>
                                        </div>
                                        <div className="pe-1">
                                            <img src={banner} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="px-4 mt-6">
                                    <div className="gap-4 sm:flex">
                                        {/* <div className="flex flex-1 p-6 rounded-lg bg-card">
                      <div className="w-full">
                        <p className="mb-1 text-base text-white">
                          My Schedule
                        </p>
                        <p className="text-sm text-UIsecondary">
                          {moment(new Date()).format("dddd MMM DD, YYYY")}
                        </p>
                        <div className="border border-[#34373E] my-4"></div>
                        {manageSchedule && manageSchedule.length ? (
                          <table className="w-full table-bordered">
                            <thead>
                              <tr className="border-0 dashboard-table">
                                <th className="p-2 text-sm font-bold text-white text-start">
                                  Start Time
                                </th>
                                <th className="p-2 text-sm font-bold text-white text-start">
                                  End Time
                                </th>
                                <th className="p-2 text-sm font-bold text-white text-start">
                                  On Demand
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {manageSchedule.map((res, index) => (
                                <tr
                                  className="border-0 dashboard-table"
                                  key={index}
                                >
                                  <td className="p-2 text-sm border-0 text-UIsecondary">
                                    {moment(res.startTime).format("hh:mm A")}
                                  </td>
                                  <td className="p-2 text-sm border-0 text-UIsecondary">
                                    {moment(res.endTime).format("hh:mm A")}
                                  </td>
                                  {res.availablePerOnDemand ? (
                                    <td className="p-2 border-0 text-success">
                                      Yes
                                    </td>
                                  ) : (
                                    <td className="p-2 border-0 text-red">
                                      No
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <div className="flex items-center justify-center text-white">
                            No Schedules Found
                          </div>
                        )}
                        <div className="flex justify-end mt-8">
                          <button
                            className="bg-UIprimary p-3 py-1.5 rounded text-white font-medium whitespace-nowrap text-sm sm:mt-0 mt-4"
                            onClick={() =>
                              this.props.history.push(
                                `${PATH.IM_PHYSICIAN.MANAGE_SCHEDULE}/${this.props.match.params.userId}`
                              )
                            }
                          >
                            Manage Schedule
                          </button>
                        </div>
                      </div>
                    </div> */}
                                        <div className="flex flex-1 p-6 mt-5 rounded-lg bg-card sm:mt-0">
                                            <div className="w-full">
                                                <div className="flex items-center justify-between">
                                                    <p className="mb-1 text-base font-semibold text-white">
                                                        {this.props.t('ongoingAppointments')}
                                                    </p>
                                                    <div className="flex items-center gap-2">
                                                        <i
                                                            className={`fal fa-chevron-left ${
                                                                todaySession &&
                                                                todaySession.length &&
                                                                sessionIndex > 0
                                                                    ? 'text-UIprimary cursor-pointer'
                                                                    : 'none text-UIprimary'
                                                            }`}
                                                            onClick={() => {
                                                                if (sessionIndex > 0) {
                                                                    this.setState({
                                                                        sessionIndex:
                                                                            sessionIndex - 1,
                                                                    });
                                                                }
                                                            }}
                                                        ></i>
                                                        <span className="inline-flex items-center px-2 py-1 text-xs font-medium text-white rounded-full bg-UIprimary">
                                                            {todaySession && todaySession.length ? (
                                                                <>
                                                                    {sessionIndex + 1} /{' '}
                                                                    {todaySession.length}
                                                                </>
                                                            ) : (
                                                                '0 / 0'
                                                            )}
                                                        </span>
                                                        <i
                                                            className={`fal fa-chevron-right ${
                                                                todaySession &&
                                                                todaySession.length &&
                                                                sessionIndex !==
                                                                    todaySession.length - 1
                                                                    ? 'text-UIprimary cursor-pointer'
                                                                    : 'none text-UIprimary'
                                                            }`}
                                                            onClick={() => {
                                                                if (
                                                                    sessionIndex !==
                                                                    todaySession.length - 1
                                                                ) {
                                                                    this.setState({
                                                                        sessionIndex:
                                                                            sessionIndex + 1,
                                                                    });
                                                                }
                                                            }}
                                                        ></i>
                                                    </div>
                                                </div>
                                                <div className="border border-[#34373E] my-4"></div>
                                                {this.state.isAppointmentLoading ? (
                                                    <Loader />
                                                ) : (
                                                    <>
                                                        {todaySession && todaySession.length ? (
                                                            <div className="flex justify-between gap-x-6 border border-[#34373E] p-4 rounded-lg">
                                                                <div className="flex gap-x-4">
                                                                    <div className="space-y-2">
                                                                        <SessionType
                                                                            sessionType={
                                                                                todaySession[
                                                                                    sessionIndex
                                                                                ].sessionType
                                                                            }
                                                                            isFromDashboard={true}
                                                                            isFromDashboardAppointment={
                                                                                true
                                                                            }
                                                                        />
                                                                        <div className="flex items-center gap-2 text-secondary">
                                                                            <svg
                                                                                width="17"
                                                                                height="16"
                                                                                viewBox="0 0 17 16"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path
                                                                                    d="M5.83334 1.33333V3.33333"
                                                                                    stroke="white"
                                                                                    strokeMiterlimit="10"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                                <path
                                                                                    d="M11.1667 1.33333V3.33333"
                                                                                    stroke="white"
                                                                                    strokeMiterlimit="10"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                                <path
                                                                                    d="M2.83334 6.06H14.1667"
                                                                                    stroke="white"
                                                                                    strokeMiterlimit="10"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                                <path
                                                                                    d="M14.5 5.66667V11.3333C14.5 13.3333 13.5 14.6667 11.1667 14.6667H5.83333C3.5 14.6667 2.5 13.3333 2.5 11.3333V5.66667C2.5 3.66667 3.5 2.33333 5.83333 2.33333H11.1667C13.5 2.33333 14.5 3.66667 14.5 5.66667Z"
                                                                                    stroke="white"
                                                                                    strokeMiterlimit="10"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                                <path
                                                                                    d="M10.9631 9.13334H10.9691"
                                                                                    stroke="white"
                                                                                    strokeWidth="1.33333"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                                <path
                                                                                    d="M10.9631 11.1333H10.9691"
                                                                                    stroke="white"
                                                                                    strokeWidth="1.33333"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                                <path
                                                                                    d="M8.497 9.13334H8.50299"
                                                                                    stroke="white"
                                                                                    strokeWidth="1.33333"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                                <path
                                                                                    d="M8.497 11.1333H8.50299"
                                                                                    stroke="white"
                                                                                    strokeWidth="1.33333"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                                <path
                                                                                    d="M6.02953 9.13334H6.03552"
                                                                                    stroke="white"
                                                                                    strokeWidth="1.33333"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                                <path
                                                                                    d="M6.02953 11.1333H6.03552"
                                                                                    stroke="white"
                                                                                    strokeWidth="1.33333"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                            </svg>
                                                                            <span className="text-sm text-white">
                                                                                {moment(
                                                                                    todaySession[
                                                                                        sessionIndex
                                                                                    ]
                                                                                        .sessionStartDate
                                                                                ).format(
                                                                                    'MMM DD, YYYY'
                                                                                )}
                                                                            </span>
                                                                        </div>
                                                                        <div className="flex items-center gap-2 text-secondary">
                                                                            <svg
                                                                                width="17"
                                                                                height="16"
                                                                                viewBox="0 0 17 16"
                                                                                fill="none"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path
                                                                                    d="M15.1667 8C15.1667 11.68 12.18 14.6667 8.50001 14.6667C4.82001 14.6667 1.83334 11.68 1.83334 8C1.83334 4.32 4.82001 1.33333 8.50001 1.33333C12.18 1.33333 15.1667 4.32 15.1667 8Z"
                                                                                    stroke="white"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                                <path
                                                                                    d="M10.9733 10.12L8.90666 8.88667C8.54666 8.67333 8.25333 8.16 8.25333 7.74V5.00667"
                                                                                    stroke="white"
                                                                                    strokeLinecap="round"
                                                                                    strokeLinejoin="round"
                                                                                />
                                                                            </svg>
                                                                            <span className="text-sm text-white">
                                                                                {' '}
                                                                                {moment(
                                                                                    todaySession[
                                                                                        sessionIndex
                                                                                    ]
                                                                                        .sessionStartDate
                                                                                ).format('hh:mm A')}
                                                                            </span>
                                                                        </div>
                                                                        <p className="text-sm text-white">
                                                                            {this.props.t(
                                                                                `${AppConfig.labels.channelName}`
                                                                            )}{' '}
                                                                            :{' '}
                                                                            {todaySession[
                                                                                sessionIndex
                                                                            ].subject
                                                                                ? todaySession[
                                                                                      sessionIndex
                                                                                  ].subject
                                                                                : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                                        </p>
                                                                        <p className="text-sm text-white">
                                                                            {this.props.t(
                                                                                'element'
                                                                            )}{' '}
                                                                            :{' '}
                                                                            {todaySession[
                                                                                sessionIndex
                                                                            ].subCategory
                                                                                ? todaySession[
                                                                                      sessionIndex
                                                                                  ].subCategory
                                                                                : RESPONSE_CONSTANT.HYPHEN}
                                                                        </p>
                                                                        <p
                                                                            className="text-sm text-white"
                                                                            title={
                                                                                todaySession[
                                                                                    sessionIndex
                                                                                ].sessionType ===
                                                                                    Scheduled ||
                                                                                todaySession[
                                                                                    sessionIndex
                                                                                ].sessionType ===
                                                                                    OnDemand ||
                                                                                todaySession[
                                                                                    sessionIndex
                                                                                ].sessionType ===
                                                                                    InPerson
                                                                                    ? todaySession[
                                                                                          sessionIndex
                                                                                      ].studentName
                                                                                    : ''
                                                                            }
                                                                        >
                                                                            {todaySession[
                                                                                sessionIndex
                                                                            ].sessionType ===
                                                                                Scheduled ||
                                                                            todaySession[
                                                                                sessionIndex
                                                                            ].sessionType ===
                                                                                OnDemand ||
                                                                            todaySession[
                                                                                sessionIndex
                                                                            ].sessionType ===
                                                                                InPerson
                                                                                ? this.props.t(
                                                                                      'teamMemberName'
                                                                                  )
                                                                                : this.props.t(
                                                                                      'numberOfTeamMembers'
                                                                                  )}{' '}
                                                                            :
                                                                            {todaySession[
                                                                                sessionIndex
                                                                            ].sessionType ===
                                                                                Scheduled ||
                                                                            todaySession[
                                                                                sessionIndex
                                                                            ].sessionType ===
                                                                                OnDemand ||
                                                                            todaySession[
                                                                                sessionIndex
                                                                            ].sessionType ===
                                                                                InPerson
                                                                                ? todaySession[
                                                                                      sessionIndex
                                                                                  ].studentName.trim() ||
                                                                                  '-'
                                                                                : todaySession[
                                                                                      sessionIndex
                                                                                  ].studentCount}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div className="flex items-center">
                                                                    <button
                                                                        className="px-5 py-1 font-medium text-white rounded-lg bg-UIprimary text-nowrap"
                                                                        onClick={() => {
                                                                            this.props.history.push(
                                                                                `${PATH.IM_PHYSICIAN.WAITINGROOM}/${this.props.match.params.userId}/${todaySession[sessionIndex].sessionId}`
                                                                            );
                                                                        }}
                                                                    >
                                                                        {this.props.t(
                                                                            'viewDetails'
                                                                        )}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="flex items-center justify-center text-white">
                                                                {this.props.t('noAppointmentFound')}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="p-4 mt-6 overflow-x-auto rounded-lg bg-card">
                                        <nav className="flex flex-col sm:flex-row gap-2 mb-6 border-b border-[#34373E]">
                                            <button
                                                className={`text-lg p-3 block hover:text-UIprimary focus:outline-none ${
                                                    this.state.tabName === 'upcoming'
                                                        ? 'text-UIprimary border-b-2 font-medium text-base'
                                                        : 'text-UIsecondary font-medium'
                                                }`}
                                                onClick={() =>
                                                    this.setState({ tabName: 'upcoming' })
                                                }
                                            >
                                                {this.props.t('upcomingSessions')}
                                            </button>
                                            <button
                                                className={`text-lg p-3 block hover:text-UIprimary focus:outline-none ${
                                                    this.state.tabName === 'recent'
                                                        ? 'text-UIprimary border-b-2 font-medium text-base'
                                                        : 'text-UIsecondary font-medium'
                                                }`}
                                                onClick={() => this.setState({ tabName: 'recent' })}
                                            >
                                                {this.props.t('recentSessions')}
                                            </button>
                                        </nav>
                                        <div id="myTabContent">
                                            {this.state.tabName === 'upcoming' ? (
                                                <div
                                                    className="overflow-x-auto"
                                                    id="upcoming"
                                                    role="tabpanel"
                                                    aria-labelledby="upcoming-tab"
                                                >
                                                    {upcomingSession && upcomingSession.length ? (
                                                        <>
                                                            {upcomingSession.map(
                                                                (session, index) => (
                                                                    <div
                                                                        className="w-full p-3 mb-6 overflow-auto rounded-lg bg-card hover:bg-black/10 lg:overflow-hidden whitespace-nowrap"
                                                                        key={index}
                                                                    >
                                                                        <div className="sm:grid md:grid-cols-7 lg:gap-4 md:gap-24">
                                                                            <div>
                                                                                <p className="mb-1 text-sm text-white">
                                                                                    {this.props.t(
                                                                                        'sessionType'
                                                                                    )}
                                                                                </p>
                                                                                <SessionType
                                                                                    className="mb-3 truncate sm:mb-0"
                                                                                    sessionType={
                                                                                        session.sessionType
                                                                                    }
                                                                                    isFromDashboard={
                                                                                        true
                                                                                    }
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                <p
                                                                                    className="mb-1 text-sm text-white truncate"
                                                                                    title={
                                                                                        session.sessionType ===
                                                                                            Scheduled ||
                                                                                        session.sessionType ===
                                                                                            OnDemand
                                                                                            ? session.studentName
                                                                                            : ''
                                                                                    }
                                                                                >
                                                                                    {session.sessionType ===
                                                                                        Scheduled ||
                                                                                    session.sessionType ===
                                                                                        OnDemand
                                                                                        ? this.props.t(
                                                                                              'teamMemberName'
                                                                                          )
                                                                                        : this.props.t(
                                                                                              'numberOfTeamMembers'
                                                                                          )}
                                                                                </p>
                                                                                <p
                                                                                    className="mb-3 text-base font-normal truncate text-UInew sm:mb-0"
                                                                                    title={
                                                                                        session.sessionType ===
                                                                                            Scheduled ||
                                                                                        session.sessionType ===
                                                                                            OnDemand
                                                                                            ? session.studentName
                                                                                            : ''
                                                                                    }
                                                                                >
                                                                                    {session.sessionType ===
                                                                                        Scheduled ||
                                                                                    session.sessionType ===
                                                                                        OnDemand
                                                                                        ? session.studentName
                                                                                        : session.studentCount}
                                                                                </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className="mb-1 text-sm text-white">
                                                                                    {this.props.t(
                                                                                        'date'
                                                                                    )}
                                                                                </p>
                                                                                <p className="mb-3 text-base font-normal text-UInew sm:mb-0">
                                                                                    {moment(
                                                                                        session.sessionStartDate
                                                                                    ).format(
                                                                                        'MMM DD, YYYY'
                                                                                    )}
                                                                                </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className="mb-1 text-sm text-white">
                                                                                    {this.props.t(
                                                                                        'time'
                                                                                    )}
                                                                                </p>
                                                                                <p className="mb-3 text-base font-normal text-UInew sm:mb-0">
                                                                                    {moment(
                                                                                        session.sessionStartDate
                                                                                    ).format(
                                                                                        'hh:mm A'
                                                                                    )}
                                                                                </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className="mb-1 text-sm text-white">
                                                                                    {this.props.t(
                                                                                        'channelName'
                                                                                    )}
                                                                                </p>
                                                                                <p className="mb-3 text-base font-normal truncate text-UInew sm:mb-0">
                                                                                    {session?.subject
                                                                                        ? session.subject
                                                                                        : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                                                </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className="mb-1 text-sm text-white">
                                                                                    {this.props.t(
                                                                                        'element'
                                                                                    )}{' '}
                                                                                </p>
                                                                                <p className="mb-3 text-base font-normal truncate text-UInew sm:mb-0">
                                                                                    {session.subCategory
                                                                                        ? session.subCategory
                                                                                        : RESPONSE_CONSTANT.HYPHEN}
                                                                                </p>
                                                                            </div>
                                                                            <div className="flex items-center justify-end mt-4 sm:mt-0 text-wrap">
                                                                                <SessionStatusButton
                                                                                    className="w-full"
                                                                                    status={
                                                                                        session.sessionStatus
                                                                                    }
                                                                                    visitId={
                                                                                        session.sessionId
                                                                                    }
                                                                                    sessionType={
                                                                                        session.sessionType
                                                                                    }
                                                                                    navigateToDetailScreen={() => {
                                                                                        this.props.history.push(
                                                                                            `${PATH.IM_PHYSICIAN.WAITINGROOM}/${this.props.match.params.userId}/${session.sessionId}`
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                            {upcomingSession.length > 3 && (
                                                                <div className="flex items-end justify-end mt-auto">
                                                                    <button
                                                                        className="rounded-lg bg-UIprimary px-3 py-1.5 text-base font-semibold text-white"
                                                                        onClick={() =>
                                                                            this.props.history.push(
                                                                                `${PATH.IM_PHYSICIAN.APPOINTMENT}/${this.props.match.params.userId}`
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="mr-2 text-white far fa-arrow-right"></i>
                                                                        {this.props.t('seeAll')}
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <div className="flex items-center justify-center text-white">
                                                            {this.props.t('noSessionsFound')}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <div
                                                    className="overflow-x-auto"
                                                    id="recent"
                                                    role="tabpanel"
                                                    aria-labelledby="recent-tab"
                                                >
                                                    {previousSession && previousSession.length ? (
                                                        <>
                                                            {previousSession.map(
                                                                (session, index) => (
                                                                    <div
                                                                        className="w-full p-3 mb-6 overflow-auto rounded-lg bg-card hover:bg-black/10 lg:overflow-hidden whitespace-nowrap"
                                                                        key={index}
                                                                    >
                                                                        <div className="sm:grid md:grid-cols-7 lg:gap-4 md:gap-24">
                                                                            <div>
                                                                                <p className="mb-1 text-sm text-white">
                                                                                    {this.props.t(
                                                                                        'sessionType'
                                                                                    )}
                                                                                </p>
                                                                                <SessionType
                                                                                    className="mb-3 truncate sm:mb-0"
                                                                                    sessionType={
                                                                                        session.sessionType
                                                                                    }
                                                                                    isFromDashboard={
                                                                                        true
                                                                                    }
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                <p
                                                                                    className="mb-1 text-sm text-white truncate"
                                                                                    title={
                                                                                        session.sessionType ===
                                                                                            Scheduled ||
                                                                                        session.sessionType ===
                                                                                            OnDemand
                                                                                            ? session.studentName
                                                                                            : ''
                                                                                    }
                                                                                >
                                                                                    {session.sessionType ===
                                                                                        Scheduled ||
                                                                                    session.sessionType ===
                                                                                        OnDemand
                                                                                        ? this.props.t(
                                                                                              'teamMemberName'
                                                                                          )
                                                                                        : this.props.t(
                                                                                              'numberOfTeamMembers'
                                                                                          )}
                                                                                </p>
                                                                                <p
                                                                                    className="mb-3 text-base font-normal truncate text-UInew sm:mb-0"
                                                                                    title={
                                                                                        session.sessionType ===
                                                                                            Scheduled ||
                                                                                        session.sessionType ===
                                                                                            OnDemand
                                                                                            ? session.studentName
                                                                                            : ''
                                                                                    }
                                                                                >
                                                                                    {session.sessionType ===
                                                                                        Scheduled ||
                                                                                    session.sessionType ===
                                                                                        OnDemand
                                                                                        ? session.studentName
                                                                                        : session.studentCount}
                                                                                </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className="mb-1 text-sm text-white">
                                                                                    {this.props.t(
                                                                                        'date'
                                                                                    )}
                                                                                </p>
                                                                                <p className="mb-3 text-base font-normal text-UInew sm:mb-0">
                                                                                    {moment(
                                                                                        session.sessionStartDate
                                                                                    ).format(
                                                                                        'MMM DD, YYYY'
                                                                                    )}
                                                                                </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className="mb-1 text-sm text-white">
                                                                                    {this.props.t(
                                                                                        'time'
                                                                                    )}
                                                                                </p>
                                                                                <p className="mb-3 text-base font-normal text-UInew sm:mb-0">
                                                                                    {moment(
                                                                                        session.sessionStartDate
                                                                                    ).format(
                                                                                        'hh:mm A'
                                                                                    )}
                                                                                </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className="mb-1 text-sm text-white">
                                                                                    {this.props.t(
                                                                                        `${AppConfig.labels.channelName}`
                                                                                    )}
                                                                                </p>
                                                                                <p className="mb-3 text-base font-normal truncate text-UInew sm:mb-0">
                                                                                    {session?.subject
                                                                                        ? session.subject
                                                                                        : RESPONSE_CONSTANT.NOT_ASSIGNED}
                                                                                </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className="mb-1 text-sm text-white">
                                                                                    {this.props.t(
                                                                                        'element'
                                                                                    )}{' '}
                                                                                </p>
                                                                                <p className="mb-3 text-base font-normal truncate text-UInew sm:mb-0">
                                                                                    {session.subCategory
                                                                                        ? session.subCategory
                                                                                        : RESPONSE_CONSTANT.HYPHEN}
                                                                                </p>
                                                                            </div>
                                                                            <div className="flex items-center justify-end mt-4 sm:mt-0 text-wrap">
                                                                                <SessionStatusButton
                                                                                    className="w-full"
                                                                                    status={
                                                                                        session.sessionStatus
                                                                                    }
                                                                                    visitId={
                                                                                        session.sessionId
                                                                                    }
                                                                                    sessionType={
                                                                                        session.sessionType
                                                                                    }
                                                                                    navigateToDetailScreen={() => {
                                                                                        this.props.history.push(
                                                                                            `${PATH.IM_PHYSICIAN.WAITINGROOM}/${this.props.match.params.userId}/${session.sessionId}`
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            )}
                                                            {previousSession.length > 3 && (
                                                                <div className="flex items-end justify-end mt-auto">
                                                                    <button
                                                                        className="rounded-lg bg-UIprimary px-3 py-1.5 text-base font-semibold text-white"
                                                                        onClick={() =>
                                                                            this.props.history.push(
                                                                                `${PATH.IM_PHYSICIAN.APPOINTMENT}/${this.props.match.params.userId}`
                                                                            )
                                                                        }
                                                                    >
                                                                        <i className="mr-2 text-white far fa-arrow-right"></i>
                                                                        {this.props.t('seeAll')}
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <div className="flex items-center justify-center text-white">
                                                            {this.props.t('noSessionsFound')}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </main>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.UserReducer.userDetails,
        todaySession: state.DashBoardReducer.todaySession,
        previousSession: state.DashBoardReducer.previousSession,
        manageSchedule: state.DashBoardReducer.manageSchedule,
        upcomingSession: state.DashBoardReducer.upcomingSession,
        deactivateUserScreen: state.NetworkInState.deactivateUserScreen,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDashboardDetails: (callback) => {
            dispatch(getDashboardDetails(callback));
        },
        getAppointmentDetails: (callback) => {
            dispatch(getAppointmentDetails(callback));
        },
    };
};

const ConnectedPhysicianDashBoard = connect(
    mapStateToProps,
    mapDispatchToProps
)(withLanguage(PhysicianDashBoard));

export default (props) => (
    <LanguageProvider>
        <ConnectedPhysicianDashBoard {...props} />
    </LanguageProvider>
);
